export class StartEnvironmentScalingResponse {
  stepFunctionExecutionArn: string;
}
